import { useEffect, useSyncExternalStore } from 'react';

/**
 * Tiny presence registry (task #140): the fixed legal footer must only be
 * hidden when a UserMenu (which carries the Impressum/Datenschutz entries)
 * is actually mounted on the current page. Some authenticated routes
 * (e.g. the transcript admin pages) render no UserMenu — there the footer
 * must stay, or the legal texts would be unreachable.
 */
let mounted = 0;
const listeners = new Set<() => void>();

function notify() { for (const l of listeners) l(); }
function subscribe(l: () => void) { listeners.add(l); return () => { listeners.delete(l); }; }
function getSnapshot() { return mounted > 0; }

/**
 * Call from UserMenu — registers its presence while `active` is true
 * (i.e. while the menu is actually rendered, not returning null).
 */
export function useRegisterUserMenu(active: boolean) {
  useEffect(() => {
    if (!active) return;
    mounted += 1;
    notify();
    return () => { mounted -= 1; notify(); };
  }, [active]);
}

/** True while at least one UserMenu is mounted. */
export function useUserMenuPresent(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot);
}
